
import React from 'react';
import { ArrowRight, Code2 } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center px-6 pt-20">
      {/* Visual background grid */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 pointer-events-none"></div>
      
      <div className="max-w-5xl mx-auto text-center z-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-emerald-500/20 bg-emerald-500/5 text-emerald-400 text-xs font-mono mb-8 uppercase tracking-widest">
          <Code2 size={14} /> GTM Engineering & Revenue Architecture
        </div>
        
        <h1 className="text-5xl md:text-8xl font-bold text-white tracking-tight mb-8 leading-[1.1]">
          I Build the <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400">Technical Engines</span> That Power Revenue.
        </h1>
        
        <div className="max-w-2xl mx-auto">
          <p className="text-lg md:text-2xl font-light text-slate-400 mb-12 leading-relaxed">
            <span className="text-white font-medium">Gbenga Michael Olaibi</span> | Bridging the gap between Sales Strategy and Engineering Reality. I automate the mundane so your team can focus on the money.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#work" 
            className="group px-8 py-4 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg font-bold transition-all flex items-center gap-2 transform hover:scale-105"
          >
            View My Work <ArrowRight className="group-hover:translate-x-1 transition-transform" />
          </a>
          <button 
            data-cal-namespace="gtm-audit-revenue-bottleneck-identification"
            data-cal-link="gbenlandia/gtm-audit-revenue-bottleneck-identification"
            data-cal-config='{"layout":"month_view","theme":"dark"}'
            className="px-8 py-4 bg-transparent border border-slate-700 hover:border-slate-500 text-slate-300 rounded-lg font-bold transition-all transform hover:scale-105"
          >
            Let's Talk Systems
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
